import React from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import styles from './styles/styles';
import MenuItemsTranslationsForm from './MenuItemsTranslationsForm';
import {
  getMenuItemTranslation,
  UpdateMenuItemTranslation,
} from '../../redux/actions/menuItemsActions';
import { snackbarShowMessage } from '../../redux/actions/snackbarActions';
import { useTranslation } from 'react-i18next';

const MenuItemsTranslationsModal = ({
  OpenMenuItemsTranslations,
  handleClose,
  MenuItemsSelected,
}: any) => {
  const { t } = useTranslation();
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );
  const classes = styles();
  const dispatch: any = useDispatch();
  const SaveTranslations = values => {
    const newValues = Object.keys(values).map(key => ({
      languageId: ~~key,
      value: values[key] === '' ? null : values[key],
    }));
    UpdateMenuItemTranslation(
      MenuItemsSelected,
      selectedBrand,
      newValues,
    )(dispatch)
      .then(result => {
        if (result.status === 400) {
          dispatch(snackbarShowMessage('app.common.messages.errorLength80'));
        } else {
          dispatch(
            snackbarShowMessage(
              'productGroups.translations.messages.updateSuccess',
            ),
          );
          dispatch(getMenuItemTranslation(MenuItemsSelected, selectedBrand));
          handleClose();
        }
      })
      .catch(result => {
        dispatch(
          snackbarShowMessage(
            'productGroups.translations.messages.updateFailed',
          ),
        );
      });
  };

  return (
    <Dialog
      maxWidth="lg"
      open={OpenMenuItemsTranslations}
      onClose={handleClose}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      aria-labelledby="max-width-dialog-title"
    >
      <DialogContent style={{ minHeight: '80vh' }}>
        <DialogTitle
          id="alert-dialog-title"
          className={classes.containerDialogTitle}
        >
          <div className={classes.divItems}>
            <Typography variant="h6">{t('menuItems.translations')}</Typography>
            <IconButton
              style={{ position: 'relative', marginLeft: '56px', padding: '0' }}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <MenuItemsTranslationsForm
          SaveTranslations={SaveTranslations}
          CloseModal={handleClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default MenuItemsTranslationsModal;
